import { clearGuestSessionStorage } from "./authSession";
import { guestUserLoginSliceAction } from "../redux/action/guestUserAction/guestUserLogin";
import { logoutHandler } from "../redux/action/logout";

export const GUEST_USER_LOGOUT_PATH = "/login";

export function guestUserLogout(dispatch, navigate) {
  dispatch(logoutHandler());
  dispatch(guestUserLoginSliceAction.guestUserLoginSliceReset());
  if (typeof navigate === "function") {
    // navigate("/guest-user/open-enrollment");
    navigate("/login")
  }
}
